import { 
  Box, 
  Typography, 
  Grid, 
} from '@material-ui/core';
import React from 'react';
import JobsPendingWidget from './Widgets/JobsPendingWidget';
import JobsOverdueWidget from './Widgets/JobsOverdueWidget';
import { RequestGroup } from './hooks/useServiceRequestSearch';

const BinDeliveriesDashboard = () => {
  return (
    <>
      <Typography variant="h1">Bin Deliveries</Typography>
      <Box mt={4}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}>
            <JobsPendingWidget title="Pending Jobs" jobGroup={RequestGroup.BinDelivery} />
          </Grid>
          <Grid item xs={12} lg={6}>
            <JobsOverdueWidget title="Overdue Jobs" jobGroup={RequestGroup.BinDelivery} />
          </Grid>
        </Grid>        
      </Box>
    </>
  );
}

export default BinDeliveriesDashboard;